// One shared preview interaction for all dynamically rendered product cards.
const cardPreviews=new WeakMap();
const runningPreviews=new Set();
const previewMotion=matchMedia('(prefers-reduced-motion: reduce)');
function transitionCardPhoto(link,image,src,alt){
 link.querySelector('.card-photo-outgoing')?.remove();
 if(image.getAttribute('src')===src){image.alt=alt;return;}
 const outgoing=image.cloneNode(false);
 outgoing.className='card-photo-outgoing';outgoing.alt='';outgoing.setAttribute('aria-hidden','true');outgoing.removeAttribute('loading');
 image.src=src;image.alt=alt;
 if(previewMotion.matches)return;
 link.append(outgoing);
 const fade=outgoing.animate([{opacity:1},{opacity:0}],{duration:420,easing:'cubic-bezier(.22,.61,.36,1)',fill:'forwards'});
 fade.finished.then(()=>outgoing.remove(),()=>outgoing.remove());
}
function stopCardPreview(link){
 const state=cardPreviews.get(link);if(!state)return;
 clearTimeout(state.timer);state.active=false;state.generation++;
 const image=link.querySelector('img');if(image)transitionCardPhoto(link,image,state.original,state.alt);
 state.counter.hidden=true;runningPreviews.delete(link);
}
function startCardPreview(link){
 if(previewMotion.matches||document.hidden)return;
 const handle=link.getAttribute('href')?.split('/').filter(Boolean).pop();
 const product=products.find(p=>p.handle===handle);const image=link.querySelector('img');
 if(!image||!product||product.images.length<2)return;
 let state=cardPreviews.get(link);
 if(!state){const counter=document.createElement('span');counter.className='card-photo-count';counter.setAttribute('aria-hidden','true');counter.hidden=true;link.append(counter);state={counter,original:image.getAttribute('src'),alt:image.alt,timer:null,generation:0,active:false};cardPreviews.set(link,state);}
 if(state.active)return;
 state.active=true;state.index=0;state.generation++;const generation=state.generation;
 state.counter.textContent='1 / '+product.images.length;state.counter.hidden=false;runningPreviews.add(link);
 function advance(){
  if(!state.active||state.generation!==generation)return;
  if(!link.isConnected||document.hidden){stopCardPreview(link);return;}
  state.index=(state.index+1)%product.images.length;
  const src=product.images[state.index]+'&width=600';const next=new Image();
  const schedule=()=>{if(state.active&&state.generation===generation)state.timer=setTimeout(advance,1400)};
  next.onload=()=>{if(!state.active||state.generation!==generation)return;transitionCardPhoto(link,image,src,product.name+' — photo '+(state.index+1));state.counter.textContent=(state.index+1)+' / '+product.images.length;schedule();};
  next.onerror=schedule;next.src=src;
 }
 state.timer=setTimeout(advance,650);
}
document.addEventListener('pointerover',e=>{if(e.pointerType==='touch')return;const link=e.target.closest('.product-image');if(link&&!link.contains(e.relatedTarget))startCardPreview(link)});
document.addEventListener('pointerout',e=>{const link=e.target.closest('.product-image');if(link&&!link.contains(e.relatedTarget))stopCardPreview(link)});
document.addEventListener('focusin',e=>{const link=e.target.closest('.product-image');if(link)startCardPreview(link)});
document.addEventListener('focusout',e=>{const link=e.target.closest('.product-image');if(link&&!link.contains(e.relatedTarget))stopCardPreview(link)});
document.addEventListener('visibilitychange',()=>{if(document.hidden)for(const link of runningPreviews)stopCardPreview(link)});
previewMotion.addEventListener('change',()=>{if(previewMotion.matches)for(const link of runningPreviews)stopCardPreview(link)});
